import { Contact as ContactSection } from "@components/sections";

export default function ContactPage() {
  return <ContactSection />;
}
